import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ChemdrawEquation = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M3.892 3.946a.946.946 0 1 0-1.892 0V18.14a.946.946 0 1 0 1.892 0v-5.678h7.57v5.678a.946.946 0 1 0 1.893 0V3.946a.946.946 0 0 0-1.893 0v6.624h-7.57V3.946ZM16.53 18.373l.411-.387c.425-.399 1.1-.399 1.525 0a.967.967 0 0 1 0 1.434l-3.137 2.951c-.69.65-.112 1.629.72 1.629h4.055c.495 0 .896-.378.896-.843 0-.466-.401-.844-.896-.844h-2.177l1.806-1.7c1.125-1.058 1.125-2.761 0-3.82-1.124-1.057-2.935-1.057-4.06 0l-.41.387a.809.809 0 0 0 0 1.193c.35.33.917.33 1.267 0ZM27.635 3.929a.929.929 0 1 0-1.857 0v2.436h-2.85a.929.929 0 1 0 0 1.857h2.85v2.85a.929.929 0 1 0 1.857 0v-2.85h2.436a.929.929 0 1 0 0-1.857h-2.436V3.93Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.506 13.16c1.815-1.929 5.218-1.929 7.033 0a5.251 5.251 0 0 1 .114 7.146L23.482 39.477c-.114.114-.227.227-.454.227L14.747 42.2c-.34 0-.794-.114-1.021-.34-.227-.227-.227-.568-.114-.908l2.383-8.054s.794-1.02 1.02-1.248H1.136C.453 31.65 0 31.083 0 30.402c0-.68.567-1.247 1.134-1.247h17.47c.27 0 .396.07.55.156.04.023.083.047.13.07L35.506 13.16ZM17.356 34.6l-1.702 5.558 5.559-1.702-3.857-3.856Zm.794-1.702 4.651 4.651 15.541-15.541-4.651-4.651L18.15 32.898Zm21.326-12.024 1.815-1.815c1.248-1.248 1.248-3.404 0-4.651-1.247-1.248-3.403-1.248-4.65 0l-1.816 1.815 4.651 4.65Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M1.475 34.146C.68 34.146 0 34.713 0 35.394c0 .68.68 1.248 1.475 1.134h8.508c2.041 0 2.041-2.382 0-2.382H1.475Z"
  }));
});
ChemdrawEquation.displayName = 'ChemdrawEquation';
ChemdrawEquation.defaultProps = {
  'aria-label': 'ChemdrawEquation'
};
export default ChemdrawEquation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ChemdrawEquation.js
// module id = 3749
// module chunks = 11